// extracted by mini-css-extract-plugin
export var button = "button-close-modal-module--button--R1KoV";
export var icon = "button-close-modal-module--icon--JYkOM";